export default __webpack_public_path__ + "static/heroSectionBg-3ad17706c0045b309aaea46c9064217d.png";